import { useState, useEffect, useContext, useMemo } from 'react'
import ContextStates from '../../context/ContextStates'
import { useFormik } from "formik"
import * as Yup from "yup"
import axios from 'axios'
import { Url } from '../Url'

// ========== ENDPOINTS COMBOS (ajustar si tu backend usa otros nombres) ==========
const GET_COMBOS_ENDPOINT = Url + 'api/combos/get.php'; // opcional si querés recargar desde backend
const SAVE_COMBOS_ENDPOINT = Url + 'api/combos/set.php'; // <-- poné acá tu endpoint real para guardar combos

// Helpers numéricos
const num = (v) => {
    if (v === null || v === undefined) return 0;
    const s = String(v).replace(/[^\d.,]/g, '').replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
};

const FEditProducto = () => {
    const [marcas, setMarcas] = useState([])
    const [marca, setMarca] = useState(0)
    const [rubros, setRubros] = useState([])
    const [rubro, setRubro] = useState(0)
    const [unidades, setUnidades] = useState([])
    const [unidad, setUnidad] = useState(0)
    const [guardar, setGuardar] = useState(false)
    const [modStock, setModStock] = useState(false)
    const [stock, setStock] = useState(0)
    const [stockMin, setStockMin] = useState(0)
    const [stockAdd, setStockAdd] = useState(0)

    // ===== Combos / escalas por cantidad (frontend) =====
    // Estructura: [{ id?: number, cantidadmin: number|string, precio_unitario: number|string }]
    const [comboRows, setComboRows] = useState([])
    const [combosDirty, setCombosDirty] = useState(false) // para saber si hay que enviar POST combos

    const { productoSelected, setProductoSelected, modify, setModify, setViewOpen, idUsuario } = useContext(ContextStates)

    // --------------------- CARGAS INICIALES ---------------------
    useEffect(() => {
        setMarca(productoSelected.idmarca)
        setRubro(productoSelected.idrubro)
        setUnidad(productoSelected.unidadmedida)
        setStock(productoSelected.stock)
        setStockMin(productoSelected.stockmin)
    }, [])

    // Combos: inicializar desde lo que ya viene en productoSelected
    useEffect(() => {
        const precios = Array.isArray(productoSelected?.precios_combo)
            ? productoSelected.precios_combo
            : []

        // Normalizo a la estructura del form
        const normalizados = precios.map(p => ({
            id: p.id, // puede venir del backend
            cantidadmin: String(p.cantidadmin ?? ''),     // como string para inputs
            precio_unitario: String(p.precio_unitario ?? ''),
            comision: String(p.comision ?? '')
        }))
        setComboRows(normalizados)
        setCombosDirty(false) // recién cargado, no hay cambios
    }, [productoSelected?.precios_combo])

    useEffect(() => {
        if (stock !== '' && stock !== 0 && stockAdd !== '' && stockAdd !== 0) {
            let aux = parseFloat(productoSelected.stock) + parseFloat(stockAdd);
            setStock(aux)
        }
    }, [stockAdd])

    useEffect(() => {
        const consultaMarcas = async () => {
            const url = Url + 'api/listadomarcas.php';
            const resultado = await axios.get(url);
            setMarcas(resultado.data.results);
        }
        consultaMarcas()
    }, [])

    useEffect(() => {
        const consultaRubros = async () => {
            const url = Url + 'api/listRubros.php';
            const resultado = await axios.get(url);
            setRubros(resultado.data.results);
        }
        consultaRubros()
    }, [])

    useEffect(() => {
        const consultaUnidades = async () => {
            const url = Url + 'api/listunidades.php';
            const resultado = await axios.get(url);
            setUnidades(resultado.data.results);
        }
        consultaUnidades()
    }, [])

    // --------------------- FORMIK ---------------------
    const formik = useFormik({
        initialValues: {
            codigo: productoSelected.codigo,
            descripcion: productoSelected.descripcion,
            descripcionExt: productoSelected.descripcionext,
            precio: productoSelected.precio,
            comision: productoSelected.comision,
            precioCosto: productoSelected.preciocosto,
            precioPromo: productoSelected.preciopromocion,
            precioMayor: productoSelected.preciopormayor,
            precioMayor2: productoSelected.preciopormayor2,
            fechaVto: productoSelected.fechavto
        },
        validationSchema: Yup.object({
            codigo: Yup.string().required("El código es necesario"),
            descripcion: Yup.string().required("La descripcion es necesaria"),
            descripcionExt: Yup.string(),
            precio: Yup.string().required("El precio es necesario"),
            precioCosto: Yup.string(),
            precioPromo: Yup.string(),
            precioMayor: Yup.string(),
            precioMayor2: Yup.string(),
        }),
        onSubmit: async (valores) => {
            if (!guardar) return;

            // 1) Guardar datos base del producto
            const formData = new FormData()
            formData.append('id', productoSelected.id);
            formData.append('codigo', valores.codigo);
            formData.append('descripcion', valores.descripcion);
            formData.append('descripcionext', valores.descripcionExt);
            formData.append('idmarca', marca);
            formData.append('idrubro', rubro);
            formData.append('unidad', unidad);
            formData.append('precio', valores.precio);
            formData.append('comision', valores.comision);
            formData.append('preciocosto', valores.precioCosto);
            formData.append('preciopromo', valores.precioPromo);
            formData.append('preciomayor', valores.precioMayor);
            formData.append('preciomayor2', valores.precioMayor2);
            formData.append('fechavto', valores.fechaVto);
            formData.append('idusuario', idUsuario);
            formData.append('numerocombo', productoSelected.numerocombo ?? '')
            formData.append('combos', JSON.stringify(comboRows))
            try {
                const response = await axios.post(Url + 'api/setProductos.php', formData)
                console.log(response)
                // 2) Si hubo cambios en combos, los enviamos
                if (combosDirty) {
                    const combosLimpiados = comboRows
                        .filter(r => Number(r.cantidadmin) > 0 && num(r.precio_unitario) > 0)
                        .map(r => ({
                            // Si tu backend necesita 'id' para actualizar, lo mandamos si existe
                            id: r.id ? Number(r.id) : undefined,
                            cantidadmin: Number(r.cantidadmin),
                            preciounitario: Number(num(r.precio_unitario)),
                            comision: Number(num(r.comision))
                        }))
                }

                // 3) Refrescos locales
                setModify((modify || 0) + 1)
                setViewOpen(false)
            } catch (e) {
                console.log(e)
                alert('No se pudieron guardar los cambios.')
            }
        }
    });

    // Precio base para mostrar previsualizaciones
    const precioBase = useMemo(() => num(formik.values.precio), [formik.values.precio])

    // --------------------- VALIDACIÓN PARA HABILITAR GUARDAR ---------------------
    useEffect(() => {
        let error = 0;
        if (!formik.values.descripcion) error = 1;
        if (!formik.values.precio) error = 1;
        if (!formik.values.codigo) error = 1;
        // if (formik.values.stock === '') error = 1; // formik no tiene 'stock'; lo manejo por fuera
        if (rubro === 0) error = 1;
        if (unidad === 0) error = 1;

        setGuardar(error === 0)
    }, [formik.values.descripcion, formik.values.codigo, formik.values.precio, /* formik.values.stock,*/ rubro, unidad])

    // --------------------- STOCK ---------------------
    const actualizarStock = async () => {
        const formData = new FormData()
        formData.append('id', productoSelected.id);
        formData.append('stock', stock);
        formData.append('stockmin', stockMin);
        try {
            await axios.post(Url + 'api/setStock.php', formData)
            let aux = (modify || 0) + 1;
            let productoAux = { ...productoSelected, stock }
            setProductoSelected(productoAux)
            setModify(aux)
            setModStock(false)
        } catch (e) {
            console.log(e)
        }
    }

    // --------------------- HANDLERS COMBOS ---------------------
    const addComboRow = () => {
        setComboRows(prev => [...prev, { id: undefined, cantidadmin: '', precio_unitario: '', comision: '' }])
        setCombosDirty(true)
    }

    const removeComboRow = (idx) => {
        setComboRows(prev => prev.filter((_, i) => i !== idx))
        setCombosDirty(true)
    }

    const clearCombos = () => {
        if (window.confirm('Esto quitará todos los combos/escala del producto. ¿Continuar?')) {
            setComboRows([])
            setCombosDirty(true)
        }
    }

    const updateComboRow = (idx, field, value) => {
        setComboRows(prev => prev.map((r, i) => (i === idx ? { ...r, [field]: value } : r)))
        setCombosDirty(true)
    }

    return (
        <div className="transition-all w-full pt-5 sm:p-3 mt-5">
            <h2 className='text-center text-gray-700 text-xl'>Edición de Productos</h2>

            <form className="w-full mt-5 py-2 px-3 rounded-2xl" onSubmit={formik.handleSubmit}>
                <div className='flex flex-wrap'>
                    {/* Columna izquierda */}
                    <div className='w-full lg:w-1/2 mx-auto m-3 p-2'>
                        <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl'>
                            <h4 className='text-center text-gray-700 uppercase'>Producto, rubro y marca</h4>

                            <label htmlFor="codigo" className="block mt-5 text-gray-600 uppercase">Código</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="codigo"
                                type="text"
                                value={formik.values.codigo}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                autoFocus
                            />
                            {formik.touched.codigo && formik.errors.codigo && (
                                <div className='w-full block text-red-500'><p>{formik.errors.codigo}</p></div>
                            )}

                            <label htmlFor="descripcion" className="block mt-5 text-gray-600 uppercase">Descripción</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="descripcion"
                                type="text"
                                value={formik.values.descripcion}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.descripcion && formik.errors.descripcion && (
                                <div className='w-full block text-red-500'><p>{formik.errors.descripcion}</p></div>
                            )}

                            <label htmlFor="descripcionExt" className="block mt-5 text-gray-600 uppercase">Descripción detallada</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="descripcionExt"
                                type="text"
                                value={formik.values.descripcionExt}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />

                            <label htmlFor="sRubro" className="w-full block mt-5 text-gray-600 uppercase">Rubro</label>
                            <select
                                className='py-2 px-3 w-full rounded bg-slate-100'
                                id='sRubro'
                                onChange={(e) => setRubro(Number(e.target.value))}
                                value={rubro}
                            >
                                {rubros?.map(item => (
                                    <option key={item.id} value={item.id}>{item.descripcion}</option>
                                ))}
                            </select>

                            <label htmlFor="sMarca" className="w-full block mt-5 text-gray-600 uppercase">Marca</label>
                            <select
                                className='py-2 px-3 w-full rounded bg-slate-100'
                                id='sMarca'
                                onChange={(e) => setMarca(Number(e.target.value))}
                                value={marca}
                            >
                                {marcas?.map(item => (
                                    <option key={item.id} value={item.id}>{item.descripcion}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Columna derecha */}
                    <div className='w-full lg:w-1/2 mx-auto m-3 p-2'>
                        <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl'>
                            <h4 className='text-center text-gray-700 uppercase'>Precio, unidad y Stock</h4>

                            <label htmlFor="precio" className="block mt-5 text-gray-600 uppercase">Precio de venta</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="precio"
                                type="text"
                                value={formik.values.precio}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.precio && formik.errors.precio && (
                                <div className='w-full block text-red-500'><p>{formik.errors.precio}</p></div>
                            )}

                            <label htmlFor="comision" className="block mt-5 text-gray-600 uppercase">Comisión</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="comision"
                                type="text"
                                value={formik.values.comision || ''}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />

                            <label htmlFor="precioCosto" className="block mt-5 text-gray-600 uppercase">Precio de costo</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="precioCosto"
                                type="text"
                                value={formik.values.precioCosto}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />

                            <label htmlFor="precioPromo" className="block mt-5 text-gray-600 uppercase">Precio de Promoción</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="precioPromo"
                                type="text"
                                value={formik.values.precioPromo}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />

                            <label htmlFor="precioMayor" className="block mt-5 text-gray-600 uppercase">Precio por mayor</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="precioMayor"
                                type="text"
                                value={formik.values.precioMayor}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />

                            <label htmlFor="precioMayor2" className="block mt-5 text-gray-600 uppercase">Precio por mayor 2</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="precioMayor2"
                                type="text"
                                value={formik.values.precioMayor2}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />

                            <label htmlFor="fechaVto" className="block mt-5 text-gray-600 uppercase">Fecha de Vencimiento</label>
                            <input
                                className="py-2 px-3 w-full border border-gray-300 rounded"
                                id="fechaVto"
                                type="date"
                                value={formik.values.fechaVto}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />

                            <label htmlFor="sUnidad" className="w-full block mt-5 text-gray-600 uppercase">Unidad de medida</label>
                            <select
                                className='py-2 px-3 w-full rounded bg-slate-100'
                                id='sUnidad'
                                onChange={(e) => setUnidad(Number(e.target.value))}
                                value={unidad}
                            >
                                {unidades?.map(item => (
                                    <option key={item.id} value={item.id}>{item.descripcion}</option>
                                ))}
                            </select>
                        </div>

                        {/* STOCK */}
                        <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl mt-4'>
                            <p className='text-lg font-bold'>Stock Actual: {productoSelected.stock}</p>
                            {modStock ? (
                                <div>
                                    <label htmlFor="stock" className="block mt-5 text-gray-600 uppercase">Nuevo Stock</label>
                                    <input
                                        className="py-2 px-3 w-full border border-gray-300 rounded"
                                        id="stock"
                                        type="text"
                                        value={stock}
                                        onChange={(e) => setStock(e.target.value)}
                                    />
                                    <label htmlFor="stockAdd" className="block mt-5 text-gray-600 uppercase">Stock a agregar</label>
                                    <input
                                        className="py-2 px-3 w-full border border-gray-300 rounded"
                                        id="stockAdd"
                                        type="text"
                                        value={stockAdd}
                                        onChange={(e) => setStockAdd(e.target.value)}
                                    />
                                    <label htmlFor="stockMin" className="block mt-5 text-gray-600 uppercase">Stock mínimo</label>
                                    <input
                                        className="py-2 px-3 w-full border border-gray-300 rounded"
                                        id="stockMin"
                                        type="text"
                                        value={stockMin}
                                        onChange={(e) => setStockMin(e.target.value)}
                                    />

                                    <div className='w-full pt-5 flex gap-3'>
                                        <button type='button' className='p-2 bg-red-500 text-white rounded' onClick={actualizarStock}>Modificar</button>
                                        <button type='button' className='p-2 bg-gray-500 text-white rounded' onClick={() => setModStock(false)}>Cancelar</button>
                                    </div>
                                </div>
                            ) : (
                                <div className='mt-5'>
                                    <button type='button' className='p-2 bg-blue-500 text-white rounded' onClick={() => setModStock(true)}>Modificar Stock</button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* ===================== COMBOS / DESCUENTOS POR CANTIDAD ===================== */}
                <div className='p-3 bg-white border border-gray-200 rounded-lg shadow-xl mt-4'>
                    <h4 className='text-center text-gray-700 uppercase'>Combos / Descuentos por cantidad</h4>
                    <p className='text-sm text-gray-600 text-center mt-1'>
                        Cargá <b>cantidad mínima</b> y <b>precio unitario</b> aplicable. Si no agregás filas, el producto no tendrá combo.
                    </p>

                    <div className='mt-4 space-y-3'>
                        {comboRows.map((row, idx) => {
                            const base = precioBase || 0;
                            const unit = num(row.precio_unitario);
                            const descuentoAprox = base > 0 && unit > 0 ? ((1 - (unit / base)) * 100) : 0;

                            return (
                                <div key={idx} className='grid grid-cols-12 gap-3 items-end border border-slate-200 rounded-lg p-3'>
                                    <div className='col-span-3'>
                                        <label className='block text-sm text-gray-600'>Cant. mín.</label>
                                        <input
                                            type='number'
                                            min={1}
                                            className='py-2 px-2 w-full border border-gray-300 rounded'
                                            value={row.cantidadmin}
                                            onChange={(e) => updateComboRow(idx, 'cantidadmin', e.target.value)}
                                        />
                                    </div>
                                    <div className='col-span-3'>
                                        <label className='block text-sm text-gray-600'>P. unitario</label>
                                        <input
                                            type='number'
                                            min={0}
                                            step='0.01'
                                            className='py-2 px-2 w-full border border-gray-300 rounded'
                                            value={row.precio_unitario}
                                            onChange={(e) => updateComboRow(idx, 'precio_unitario', e.target.value)}
                                        />
                                    </div>
                                    <div className='col-span-3'>
                                        <label className='block text-sm text-gray-600'>Comisión</label>
                                        <input
                                            type='number'
                                            min={0}
                                            step='0.01'
                                            className='py-2 px-2 w-full border border-gray-300 rounded'
                                            value={row.comision}
                                            onChange={(e) => updateComboRow(idx, 'comision', e.target.value)}
                                        />
                                    </div>
                                    <div className='col-span-2'>
                                        <label className='block text-sm text-gray-600'>Desc.</label>
                                        <div className='py-2 px-1 w-full border border-gray-100 rounded bg-slate-50 text-slate-700 text-xs text-center flex items-center h-[42px] justify-center'>
                                            {base > 0 && unit > 0 ? `${descuentoAprox.toFixed(2)}%` : '-'}
                                        </div>
                                    </div>
                                    <div className='col-span-1 flex justify-end pb-[6px]'>
                                        <button
                                            type='button'
                                            className='px-2 py-2 rounded bg-red-500 text-white'
                                            onClick={() => removeComboRow(idx)}
                                            title='Quitar'
                                        >
                                            X
                                        </button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className='mt-4 flex gap-3'>
                        <button type='button' className='px-3 py-2 rounded bg-blue-600 text-white' onClick={addComboRow}>
                            + Agregar escala
                        </button>
                        {comboRows.length > 0 && (
                            <button type='button' className='px-3 py-2 rounded bg-gray-600 text-white' onClick={clearCombos}>
                                Quitar todas
                            </button>
                        )}
                    </div>
                </div>
                {/* ========================================================================== */}

                <div className="mt-auto">
                    <div className="w-full rounded-lg px-3">
                        <input
                            type="submit"
                            className={`w-full shadow-md p-3 text-gray-100 transition-all uppercase font-bold rounded-lg mt-5 ${guardar ? 'bg-orange-600 hover:bg-orange-500' : 'bg-orange-300 cursor-not-allowed'}`}
                            value="Guardar Datos"
                        />
                    </div>
                </div>
            </form>
        </div>
    )
}

export default FEditProducto
